export default __webpack_public_path__ + "static/media/water_level_0.1907a6c3.png";